import { render } from "./InternalBoard.vue?vue&type=template&id=4b909a57"
import script from "./InternalBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalBoard.vue?vue&type=script&setup=true&lang=js"

import "./InternalBoard.vue?vue&type=style&index=0&id=4b909a57&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/boards/InternalBoard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b909a57"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b909a57', __exports__)) {
    api.reload('4b909a57', __exports__)
  }
  
  module.hot.accept("./InternalBoard.vue?vue&type=template&id=4b909a57", () => {
    api.rerender('4b909a57', render)
  })

}


export default __exports__